export function isValidCarPlate(plate) {
   plate = plate.replace(/[\s-]/g, "").toUpperCase();

   // Aceita placas entre 5 e 8 caracteres alfanuméricos
   return /^[A-Z0-9]{5,8}$/.test(plate);
}